var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.tags),function(tag){return _c('el-tag',{key:tag,attrs:{"size":"medium","closable":false}},[_vm._v(_vm._s(tag))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }